<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.appellation.create")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineAppellationForm :APIbaseURL="APIbaseURL" :appellation="appellation" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineAppellationForm } from 'aveine-appellation';
import { Appellation } from 'aveine-toolbox';

export default {
  data () {
    return {
      appellation: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineAppellationForm
  },
  async created() {
    this.appellation = await Appellation.new()
    
    this.appellation.$isNew = true;
    this.dataLoaded = true;
  },
}
</script>
